<template>
  <div>
    <b-modal
      ref="modal-setting-service-type"
      :title="$t(getTitleModal)"
      modal-class="modal-primary"
      @hidden="$emit('hideModal')"
      scrollable
      size="sm"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="">
        <ValidationObserver ref="ref-validation-service-type">
          <b-row>
            <!-- Client -->
            <b-col sm="12">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="client_name"
              >
                <b-form-group
                  :label="$t('Client')"
                  label-for="client_name"
                  :state="errors[0] ? false : null"
                >
                  <b-skeleton v-if="!finishedLoading" type="input" />
                  <!-- <v-select
                    v-if="finishedLoading"
                    id="client_id"
                    v-model="form.client_id"
                    :options="clients"
                    append-to-body
                    :calculate-position="positionDropdown"
                    :placeholder="`${$t('Search')}...`"
                    :reduce="(l) => l.id"
                    label="name"
                  /> -->
                  <b-form-input
                    v-if="finishedLoading"
                    id="client_name"
                    v-model="form.client_name"
                    trim
                    :disabled="true"
                  />
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <!-- Name of service type -->
            <b-col sm="12">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="name"
              >
                <b-form-group
                  :label="$t('Service Type')"
                  label-for="name"
                  :state="errors[0] ? false : null"
                >
                  <b-skeleton v-if="!finishedLoading" type="input" />
                  <b-form-input
                    v-if="finishedLoading"
                    id="name"
                    v-model="form.name"
                    trim
                    :state="errors[0] ? false : null"
                  />
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>
        </ValidationObserver>
      </div>

      <template #modal-footer>
        <div class="d-flex justify-content-end">
          <b-button @click="registerServiceType" variant="outline-success">{{
            $t("REGISTER")
          }}</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import modalMixin from "@/mixins/modal";
import ClientsService from "@/views/commons/clients/services/clients.service";

export default {
  mixins: [modalMixin],
  props: {
    clientId: {
      default: null,
    },
  },
  data() {
    return {
      form: {
        id: null,
        client_id: null,
        client_name: "",
        name: "",
      },
      finishedLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    getTitleModal() {
      //   if (this.routeId == null) return "NEW SERVICE TYPE";
      return "NEW SERVICE TYPE";
    },
  },
  watch: {},
  mounted() {
    this.toggleModal("modal-setting-service-type");
  },
  async created() {
    try {
      this.form.client_id = this.clientId;
      this.finishedLoading = false;
      this.addPreloader();
      await Promise.all([this.getClientById()]);
    } catch (error) {
      console.log(error);
      this.showToastError(error?.response?.data?.message);
    } finally {
      this.finishedLoading = true;
      this.removePreloader();
    }
  },
  methods: {
    async registerServiceType() {
      const result = await this.$refs["ref-validation-service-type"].validate();
      if (!result) return;

      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;

      try {
        this.addPreloader();
        const params = {
          client_id: this.form.client_id,
          name: this.form.name,
          user_id: this.currentUser.id,
        };
        const { data } = await ClientsService.registerServiceType(params);
        if (data.type == "warning") {
          this.showToastWarning(data.message);
          return;
        }
        if (data.type == "success") this.showToastSuccess(data.message);
        this.$emit("registered");
      } catch (error) {
        console.log(error);
        this.showToastError(error?.response?.data?.message);
      } finally {
        this.removePreloader();
      }
    },

    async getClientById() {
      try {
        const { data } = await ClientsService.getDataClientById({
          client_id: this.form.client_id,
        });
        this.form.client_name = data[0].business_name;
      } catch (error) {
        throw error;
      }
    },
  },
};
</script>

<style>
</style>